export const ContentWidth = {
  Fluid: 'fluid',
  Boxed: 'boxed',
} as const

export const NavbarType = {
  Sticky: 'sticky',
  Static: 'static',
  Hidden: 'hidden',
} as const

export const FooterType = {
  Sticky: 'sticky',
  Static: 'static',
  Hidden: 'hidden',
} as const

export const AppContentLayoutNav = {
  Vertical: 'vertical',
  // Horizontal: 'horizontal', // 删除横向布局选项
} as const

// 删除 HorizontalNavType，因为我们只使用垂直布局
// export const HorizontalNavType = {
//   Sticky: 'sticky',
//   Static: 'static',
//   Hidden: 'hidden',
// } as const
